import selector from "utils/issues/editor/parameter_value_selector";
export default selector;
